/**
 * The alias to this folder is shop/orders
 *
 * Consider using this file as entry point to the container.
 * Ideally, you should import, bind and register all req  required modules or components from here
 */
import CartMixin from './_mixins/cart'
import * as vuex from './vuexstore'
import components from './components'

export default {
  vuex,
  'mixins': {CartMixin},
  components,
}


